import { Update, Init } from '~/mvuReducer'
import { CallBotAction, CallBotLayoutInfo } from './types'

export type Callbacks = {
  buttonClicked: (buttonType: CallBotAction, id: string, url?: string, eventIntegrationReferenceId?: string) => void
}

export type State = {
  layoutInfos: CallBotLayoutInfo[]
}

type UpdateLayoutInfos = {
  action: 'update-layout-infos'
  layoutInfos: CallBotLayoutInfo[]
}

type ButtonClick = {
  action: 'button-click'
  buttonType: CallBotAction
  id: string
  url?: string
  eventIntegrationReferenceId?: string
}

export type Action = UpdateLayoutInfos | ButtonClick

export type Dispatch = (action: Action) => void

type ButtonClickedEffect = {
  effect: 'button-clicked'
  buttonType: CallBotAction
  infoId: string
  url?: string
  eventIntegrationReferenceId?: string
}

export type SideEffect = ButtonClickedEffect

export function initialize(layoutInfos: CallBotLayoutInfo[]): Init<State, SideEffect, Action> {
  return {
    state: { layoutInfos },
    sideEffects: [],
    subscriptions: [],
  }
}

export function applyAction(state: State, action: Action): Update<State, SideEffect> {
  switch (action.action) {
    case 'update-layout-infos':
      return [{ ...state, layoutInfos: action.layoutInfos }, []]

    case 'button-click':
      return [
        state,
        [
          {
            effect: 'button-clicked',
            buttonType: action.buttonType,
            infoId: action.id,
            url: action.url,
            eventIntegrationReferenceId: action.eventIntegrationReferenceId,
          },
        ],
      ]
  }
}

export function makeSideEffectExecutor({
  buttonClicked,
}: Callbacks): (sideEffect: SideEffect, dispatch: Dispatch) => void {
  return async (sideEffect: SideEffect, _dispatch: Dispatch) => {
    switch (sideEffect.effect) {
      case 'button-clicked': {
        buttonClicked(sideEffect.buttonType, sideEffect.infoId, sideEffect.url, sideEffect.eventIntegrationReferenceId)
        break
      }
    }
  }
}
